import { Controller } from "@hotwired/stimulus"

// MS50 #3003 — shared "nested-fields" add/remove-row controller.
//
// CSP-safe replacement for the nonce-less inline <script> row-cloning and the
// inline `onclick="this.closest('.row').remove()"` handlers the enforcing nonce
// CSP (#1222; script-src :self + nonce, no unsafe_inline) silently blocked.
// Shared by the custom_fields, field_templates, and workflow-states forms — the
// same add/remove pattern in all three (kills the per-site duplicated markup).
//
// Markup contract:
//   <div data-controller="nested-fields">
//     <div data-nested-fields-target="container">
//       <div data-nested-fields-row>
//         ... <button data-action="click->nested-fields#remove">Remove</button>
//       </div>
//     </div>
//     <template data-nested-fields-target="template">
//       <div data-nested-fields-row> ... same shape, no inline onclick ... </div>
//     </template>
//     <button data-action="click->nested-fields#add">Add</button>
//   </div>
//
// `add` clones the <template> content (replacing the "NEW_RECORD" nested-attribute
// index placeholder with a unique value) and appends it to the container.
// `remove` removes the row from the DOM, or — for a persisted nested record whose
// row carries a `_destroy` hidden input — marks it for destruction and hides it.
export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()

    const markup = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", markup)
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-nested-fields-row]")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      // Persisted nested record: flag for destruction on submit, hide the row.
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
